import NotifyList from "./NotifyList";

export default NotifyList